import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import "../../../../src/styles/userManagement.css";
import UpdateRisk from "../Analyst/ChangeRequests"
import displayToastMessage from "../../../components/Common/Alert/displayToastMessage";
import APIService from "../../../services/apiAxiosService.js";
import useHttp from "../../../hooks/useHttp.js";
export default function AnalystRisks(props) {
  const [currentTab, setCurrentTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [changeRequestsRiskData, setChangeRequestsRiskData] = useState([]);
  const [allClassifications, setAllClassifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allVendorList, setAllVendorList] = useState([]);
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getAllClassifications } = useHttp();
  const { sendRequest: getChangeRequestsRiskData } = useHttp();
  const { sendRequest: deleteRiskRequestByID } = useHttp();
  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset);
  };
  const ChangeTab = (id) => {
    setCurrentTab(id)
  }

  const getAllVendorListData = async () => {
    getAllVendorList(APIService.getAllVendorList(), (data) => {
      setAllVendorList(data.MSG)
    })
  };
  const getAllClassificationsData = async () => {
    getAllClassifications(APIService.getAllClassifications(), (data) => {
      setAllClassifications(data.MSG);
    })
  };
  const getChangeRequestsRisk = async () => {
    getChangeRequestsRiskData(APIService.getChangeRequestsRiskData(), (res) => {
      if (res.CODE) {
        res.MSG.forEach(function (a) {
          a.expiray_date = a.expiray_date.substring(0, 10);
          a.date_issued = a.date_issued.substring(0, 10);
        });
        setChangeRequestsRiskData(res.MSG);
      }
    })
  };

  const handleDelete = async (vendorId) => {
    setLoading(true);
    try {
      deleteRiskRequestByID(APIService.deleteRiskRequestByID(vendorId), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage(result.MSG, "success");
          getChangeRequestsRisk();
        } else {
          setLoading(false);
          displayToastMessage("Something went wrong!", "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
    }
  };

  useEffect(() => {
    getChangeRequestsRisk();
    getAllVendorListData();
    getAllClassificationsData();
  }, []);

  return (
    <div className="App">
      <div className="user-management-container">
        <Tabs
          defaultValue={currentTab}
          value={currentTab}
          onChange={handleTabs}
          className="a-tab-item-padding-10"
        >
          <Tab value="1" label="Change Requests">
            < UpdateRisk SetTab={ChangeTab}
              reset={reset}
              changeRequestsRiskData={changeRequestsRiskData}
              allVendorList={allVendorList}
              allClassifications={allClassifications}
              handleDelete={handleDelete}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  )
};
